import type {
  CustomerZoneCreateRequestType,
  CustomerZoneCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useCustomerZonesCreate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: CustomerZoneCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `customer-zones`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse(response).data as CustomerZoneCreateResponseType,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.SupplierStorefrontV2],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.CustomerZones],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Suppliers],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.SuppliersLegacy],
      });
    },
  });
};
